<template>
  <b-btn @click="gotoTop()" :type="type">
    <slot></slot>
  </b-btn>
</template>

<script>
export default {
  name: "Bt1",
  props: ["type"],
  methods:{
    gotoTop(){
      window.scroll(0,0)
    }
  }
};
</script>

<style>

</style>